import { render, staticRenderFns } from "./Muolajalar.vue?vue&type=template&id=27751f88"
import script from "./Muolajalar.vue?vue&type=script&lang=js"
export * from "./Muolajalar.vue?vue&type=script&lang=js"
import style0 from "./Muolajalar.vue?vue&type=style&index=0&id=27751f88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports